import React, { useState, useEffect } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import './Grupos.css';

const API = process.env.REACT_APP_API_URL;

const api = async (body) => {
  const res = await fetch(`${API}/prod/grupos`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
  const data = await res.json();
  return typeof data.body === 'string' ? JSON.parse(data.body) : data.body || data;
};

export default function Grupos() {
  const [msisdn, setMsisdn] = useState('');
  const [grupo, setGrupo] = useState(null);
  const [lineas, setLineas] = useState([]);
  const [consumos, setConsumos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [nombreGrupo, setNombreGrupo] = useState('');
  const [newMsisdn, setNewMsisdn] = useState('');
  const [newAlias, setNewAlias] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    // Prioridad: grupo guardado > formData
    const savedGrupo = localStorage.getItem('grupo_admin');
    if (savedGrupo) {
      setMsisdn(savedGrupo);
      loadGrupo(savedGrupo);
    } else {
      const saved = JSON.parse(localStorage.getItem('formData') || '{}');
      if (saved.msisdn) { setMsisdn(saved.msisdn); loadGrupo(saved.msisdn); }
    }
  }, []);

  const loadGrupo = async (num) => {
    const r = await api({ action: 'mi_grupo', msisdn_admin: num });
    setGrupo(r.grupo);
    setLineas(r.lineas || []);
    if (r.grupo) {
      localStorage.setItem('grupo_admin', num);
      loadConsumos(num);
    }
  };

  const loadConsumos = async (num) => {
    setLoading(true);
    try {
      const r = await api({ action: 'consumos', msisdn_admin: num });
      setConsumos(r.lineas || []);
    } catch { }
    finally { setLoading(false); }
  };

  const crearGrupo = async () => {
    if (!msisdn || !nombreGrupo) { toast.warn('Ingresa tu número y nombre del grupo'); return; }
    const r = await api({ action: 'crear', msisdn_admin: msisdn, nombre: nombreGrupo });
    if (r.ok) { toast.success('Grupo creado'); loadGrupo(msisdn); }
    else toast.error(r.error);
  };

  const agregarLinea = async () => {
    if (!newMsisdn) { toast.warn('Ingresa el número'); return; }
    const r = await api({ action: 'agregar', msisdn_admin: msisdn, msisdn: newMsisdn, alias: newAlias });
    if (r.ok) { toast.success('Línea agregada'); setNewMsisdn(''); setNewAlias(''); loadGrupo(msisdn); }
    else toast.error(r.error);
  };

  const eliminarLinea = async (num) => {
    const r = await api({ action: 'eliminar_linea', msisdn_admin: msisdn, msisdn: num });
    if (r.ok) { toast.success('Línea eliminada'); loadGrupo(msisdn); }
    else toast.error(r.error);
  };

  return (
    <div className="grupos-page">
      <div className="grupos-hero">
        <h1>👨‍👩‍👧‍👦 Mi Grupo</h1>
        <p>Administra las líneas de tu familia o empresa en un solo lugar</p>
      </div>

      {!grupo ? (
        <div className="grupos-card">
          <h3 style={{ color: '#1a3a2a', margin: '0 0 6px 0' }}>Crear tu grupo</h3>
          <p style={{ fontSize: 13, color: '#6b8f71', margin: '0 0 14px 0' }}>
            Tu número será el administrador del grupo. Podrás ver los consumos y recargar todas las líneas.
          </p>
          <input className="grupos-input" placeholder="Tu número admin (10 dígitos)" type="tel" maxLength={10} value={msisdn} onChange={(e) => setMsisdn(e.target.value)} />
          <input className="grupos-input" placeholder="Nombre del grupo (ej: Familia García)" value={nombreGrupo} onChange={(e) => setNombreGrupo(e.target.value)} />
          <button className="grupos-btn" onClick={crearGrupo}>Crear Grupo</button>
          <div style={{ marginTop: 14, textAlign: 'center' }}>
            <span style={{ fontSize: 13, color: '#6b8f71' }}>¿Ya tienes grupo? Ingresa tu número admin y </span>
            <button onClick={() => { if (msisdn) loadGrupo(msisdn); }} style={{ background: 'none', border: 'none', color: '#2d6a4f', fontWeight: 700, cursor: 'pointer', fontSize: 13 }}>
              consulta aquí
            </button>
          </div>
        </div>
      ) : (
        <>
          <div className="grupos-card">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
              <div>
                <div style={{ fontSize: 18, fontWeight: 800, color: '#1a3a2a' }}>{grupo.nombre}</div>
                <div style={{ fontSize: 13, color: '#6b8f71' }}>{lineas.length} líneas · Admin: {msisdn}</div>
              </div>
              <button onClick={() => loadConsumos(msisdn)} style={{ padding: '8px 16px', borderRadius: 10, background: '#1a3a2a', color: '#fff', border: 'none', fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>
                🔄 Actualizar
              </button>
            </div>

            {/* Agregar línea */}
            <div style={{ display: 'flex', gap: 8, marginBottom: 14 }}>
              <input className="grupos-input" style={{ marginBottom: 0, flex: 1 }} placeholder="Número" type="tel" maxLength={10} value={newMsisdn} onChange={(e) => setNewMsisdn(e.target.value)} />
              <input className="grupos-input" style={{ marginBottom: 0, flex: 1 }} placeholder="Alias (Mamá, Oficina...)" value={newAlias} onChange={(e) => setNewAlias(e.target.value)} />
              <button onClick={agregarLinea} style={{ padding: '12px 16px', borderRadius: 10, background: '#2d6a4f', color: '#fff', border: 'none', fontWeight: 700, cursor: 'pointer', whiteSpace: 'nowrap' }}>+</button>
            </div>
          </div>

          {/* Consumos */}
          {loading ? (
            <div style={{ textAlign: 'center', padding: 30, color: '#6b8f71' }}>Consultando líneas...</div>
          ) : (
            consumos.map((c) => (
              <div className="grupos-linea" key={c.msisdn}>
                <div className="grupos-linea-info">
                  <div className="grupos-linea-name">{c.alias || c.msisdn}</div>
                  <div className="grupos-linea-num">📞 {c.msisdn}</div>
                  {c.info && !c.info.error && (
                    <>
                      <span className={`grupos-status ${/activ/i.test(c.info.estatus) ? 'active' : 'inactive'}`}>
                        {c.info.estatus}
                      </span>
                      <span style={{ fontSize: 12, color: '#6b8f71', marginLeft: 8 }}>Vence: {c.info.fecha_vencimiento}</span>
                      <div className="grupos-consumo">
                        {c.info.datos !== undefined && <span className="grupos-consumo-tag">📊 {c.info.datos} GB</span>}
                        {c.info.min !== undefined && <span className="grupos-consumo-tag">📞 {c.info.min} Min</span>}
                        {c.info.sms !== undefined && <span className="grupos-consumo-tag">💬 {c.info.sms} SMS</span>}
                      </div>
                    </>
                  )}
                  {c.info?.error && <div style={{ fontSize: 12, color: '#ef4444' }}>Error al consultar</div>}
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                  <button onClick={() => navigate(`/Consulta?msisdn=${c.msisdn}`)} style={{ padding: '8px 12px', borderRadius: 8, background: '#2d6a4f', color: '#fff', border: 'none', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>
                    Recargar
                  </button>
                  {c.msisdn !== msisdn && (
                    <button onClick={() => eliminarLinea(c.msisdn)} style={{ padding: '6px 12px', borderRadius: 8, background: '#fef2f2', color: '#ef4444', border: 'none', fontSize: 11, cursor: 'pointer' }}>
                      Quitar
                    </button>
                  )}
                </div>
              </div>
            ))
          )}
        </>
      )}

      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
}
